import React, {Component, createRef} from 'react';
import MapViewer from './map_viewer';


export default class ChatUsersMap extends Component {
  constructor(props) {
    super(props);
    this.all_markers = buildMarkers(props.chat_user_sessions);
    this.cancer_types = buildCancerTypesList(props.chat_user_sessions);
    this.state = {markers: this.all_markers, cancer_type_id: ""};

    this.selectCancerType = this.selectCancerType.bind(this);
    this.selectChatScript = this.selectChatScript.bind(this);
    this.calculateMapHeight = this.calculateMapHeight.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.map_container = createRef();
  }

  componentDidMount() {
    window.addEventListener("resize", this.calculateMapHeight);
    this.calculateMapHeight();
  }


  componentWillUnmount() {
    window.removeEventListener("resize", this.calculateMapHeight);
  }

  calculateMapHeight() {
    let window_height = window.innerHeight;
    let map_container_position = this.map_container.current.getBoundingClientRect().top;

    let height = window_height - map_container_position - 55;
    this.setState({height});
  }


  applyFilters() {
    let {cancer_type_id, chat_script_id} = this.state;
    let markers;

    if (!cancer_type_id && !chat_script_id) {
      markers = this.all_markers;
    } else {
      markers =  this.all_markers.filter(marker => {
        if (cancer_type_id && marker.cancer_type_id !== cancer_type_id) return false;
        if (chat_script_id && marker.chat_script_id !== chat_script_id) return false;
        return true;
      });
    }
    this.setState({markers});
  }


  selectCancerType(e) {
    let cancer_type_id = +e.target.value;
    this.setState({cancer_type_id}, this.applyFilters);
  }

  selectChatScript(e) {
    let chat_script_id = +e.target.value;
    this.setState({chat_script_id}, this.applyFilters);

  }

  renderCancerTypeSelector() {
    let {cancer_type_id} = this.state;
    return (
      <div>
        <label>Cancer Type</label>
        <select value={cancer_type_id} onChange={this.selectCancerType}>
          <option value="">Show All</option>
          {this.cancer_types.map(cancer_type => {
            return <option key={cancer_type.id} value={cancer_type.id}>{cancer_type.label}</option>
          })}
        </select>
      </div>
    )
  }

  renderChatScriptSelector() {
    let {chat_scripts} = this.props;
    let {chat_script_id} = this.state;
    return (
      <div>
        <label>Chat Script</label>
        <select value={chat_script_id} onChange={this.selectChatScript}>
          <option value="">Show All</option>
          {chat_scripts.map(chat_script => {
            return <option key={chat_script.id} value={chat_script.id}>{chat_script.name}</option>
          })}
        </select>
      </div>
    )
  }


  render() {
    let {markers, height} = this.state;

    return (
      <div>
        <hr/>
        {this.renderCancerTypeSelector()}
        {this.renderChatScriptSelector()}
        <hr/>
        <div className="row">
          <div className="col-md-4">
              <MapUserDetails chat_user_sessions={markers} />
          </div>
          <div className="col-md-8">
            <div id="map_container" ref={this.map_container}>
              <MapViewer height={height} markers={markers} onClickOnMap={e => this.setState({selected: null})} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}


class MapUserDetails extends Component {
  constructor(props) {
    super(props);
    let countries = groupChatUsers(props.chat_user_sessions);
    this.state = {countries};
  }

  static getDerivedStateFromProps(props, state) {
    state.countries = groupChatUsers(props.chat_user_sessions);
    return state;
  }

  render() {
    let {countries} = this.state;
    return (
      <div>
      {countries.map(country => {
        let results_by_country = country.states.reduce((acc, s) => acc + s.count, 0);
        return (
          <div key={country.country_code}>
            <h3>{country.name}</h3>
            <table className="table table-condensed">
              <thead>
                <tr>
                  <th>State</th>
                  <th>Chat User Sessions</th>
                </tr>
              </thead>

              <tbody>
                {country.states.map(state => {
                  return (
                    <tr key={state.name}>
                      <td>{state.name}</td>
                      <td>{state.count}</td>
                    </tr>
                  )
                })}

                <tr>
                  <td><strong>TOTAL</strong></td>
                  <td><strong>{results_by_country}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        )
      })}
      </div>
    )
  }
}

function buildMarkers(chat_user_sessions) {
  return chat_user_sessions.map(chat_user => {
    chat_user.grouped = true;
    chat_user.title = chat_user.cancer_type_name;
    chat_user.data = {foo: 1};
    return chat_user;
  });
}

function buildCancerTypesList(chat_user_sessions) {
  let collection = {};

  for(let chat_user of chat_user_sessions) {
    collection[chat_user.cancer_type_id] = chat_user.cancer_type_name;
  }

  return Object.keys(collection).map(cancer_type_id => {
    return {id: cancer_type_id, label: collection[cancer_type_id]}
  });
}


function groupChatUsers(chat_user_sessions) {
  let countries = [{country_code: 'us', name: 'United States', states: []}]
  for (let chat_user of chat_user_sessions) {
    let address = chat_user.address;
    let country = countries.find(c => c.country_code === address.country_code);
    if (!country) {
      country = {country_code: address.country_code, name: address.country, states: []}
      countries.push(country);
    }

    let state = country.states.find(s => s.name == address.state);
    if (!state) {
      state = {name: address.state, count: 0};
      country.states.push(state);
    }
    state.count++;
  }

  return countries;
}
